module.exports = __webpack_public_path__ + "static/img/news5detail1.1ba406a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news5detail1.png
// module id = PqGq
// module chunks = 0